import { ConfirmDialog, Typography } from '@occc-app/design-system';

import { SegmentAssignMemberships } from './segment-assign-memberships.component';
import { useSegmentAssignMembershipsController } from './use-segment-assign-memberships-controller.hook';

type SegmentAssignMembershipsControllerProps = {
  uuid: string;
  membershipCount: number;
  onLoadingStateChange?: (loading: boolean) => void;
  onMembershipsChanged?: (baselineMembershipCount: number) => void;
  shouldDisableControls?: boolean;
};

export const SegmentAssignMembershipsController = ({
  uuid,
  membershipCount,
  onLoadingStateChange,
  onMembershipsChanged,
  shouldDisableControls = false,
}: SegmentAssignMembershipsControllerProps) => {
  const {
    loading,
    addMembers,
    onRemoveMembersFromSegmentClick,
    membershipInputValue,
    setMembershipInputValue,
    isRemoveMembersConfirmationOpen,
    onRemoveMembersConfirmationClose,
    removeMembers,
  } = useSegmentAssignMembershipsController({
    uuid,
    membershipCount,
    onLoadingStateChange,
    onMembershipsChanged,
  });

  return (
    <>
      <SegmentAssignMemberships
        shouldDisableControls={loading || shouldDisableControls}
        onAddMembersToSegment={addMembers}
        onRemoveMembersFromSegmentClick={onRemoveMembersFromSegmentClick}
        membershipInputValue={membershipInputValue}
        onMembershipInputChange={setMembershipInputValue}
      />

      <ConfirmDialog
        dialogTitle='Remove Memberships from Segment'
        open={isRemoveMembersConfirmationOpen}
        onClose={onRemoveMembersConfirmationClose}
        confirmButtonText='Confirm'
        confirmButtonProps={{
          onClick: removeMembers,
          color: 'error',
        }}
      >
        <Typography>
          Members with listed IDs will be removed from this segment. Are you sure you want to do
          that?
        </Typography>
      </ConfirmDialog>
    </>
  );
};
